import React, { useState, useRef, useEffect } from 'react'

/* ── SF Symbol SVG Icons ── */
const TrashFillIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 12 14" fill="#fff">
    <path d="M3.08789 13.2246C2.17969 13.2246 1.60547 12.6855 1.56445 11.7832L1.16602 3.33398H0.515625C0.234375 3.33398 0 3.11133 0 2.81836C0 2.53125 0.234375 2.30859 0.515625 2.30859H3.11719V1.42969C3.11719 0.533203 3.69141 0 4.6582 0H6.88477C7.85742 0 8.42578 0.533203 8.42578 1.42969V2.30859H11.0332C11.3262 2.30859 11.5547 2.53125 11.5547 2.81836C11.5547 3.11133 11.3262 3.33398 11.0332 3.33398H10.3887L9.99023 11.7773C9.94922 12.6797 9.36914 13.2246 8.47266 13.2246H3.08789ZM4.19531 1.48242V2.30859H7.34766V1.48242C7.34766 1.17773 7.13672 0.984375 6.80859 0.984375H4.73438C4.40625 0.984375 4.19531 1.17773 4.19531 1.48242ZM3.97852 11.4082C4.23633 11.4082 4.40625 11.2441 4.39453 11.0039L4.21289 4.63477C4.20703 4.38281 4.03125 4.23047 3.79102 4.23047C3.5332 4.23047 3.36914 4.38867 3.375 4.63477L3.55078 11.0098C3.5625 11.2559 3.72656 11.4082 3.97852 11.4082ZM5.77734 11.4082C6.0293 11.4082 6.20508 11.25 6.20508 11.0098V4.63477C6.20508 4.38867 6.0293 4.23047 5.77734 4.23047C5.52539 4.23047 5.34961 4.38867 5.34961 4.63477V11.0098C5.34961 11.25 5.52539 11.4082 5.77734 11.4082ZM7.57617 11.4082C7.82227 11.4082 7.98633 11.2559 7.99805 11.0098L8.17969 4.63477C8.18555 4.38867 8.02148 4.23047 7.76367 4.23047C7.51758 4.23047 7.34766 4.38867 7.3418 4.63477L7.1543 11.0039C7.14844 11.25 7.31836 11.4082 7.57617 11.4082Z"/>
  </svg>
)

const StarFillIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 14 13" fill="#fff">
    <path d="M2.60742 12.4863C2.33203 12.2812 2.27344 11.9414 2.43164 11.4785L3.63867 7.89844L0.5625 5.68945C0.164062 5.4082 0 5.09766 0.111328 4.76953C0.222656 4.44727 0.527344 4.29492 1.01367 4.29492H4.78711L5.93555 0.720703C6.08789 0.251953 6.32812 0 6.66797 0C7.01367 0 7.25391 0.251953 7.40039 0.720703L8.54883 4.29492H12.3223C12.8086 4.29492 13.1191 4.44727 13.2305 4.76953C13.3418 5.09766 13.1719 5.4082 12.7793 5.68945L9.70312 7.89844L10.9043 11.4785C11.0625 11.9414 11.0039 12.2812 10.7344 12.4863C10.459 12.6973 10.1133 12.627 9.71484 12.3398L6.66797 10.1016L3.62109 12.3398C3.22266 12.627 2.88281 12.6973 2.60742 12.4863Z"/>
  </svg>
)

const StarSmallIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 14 13" fill="#fff">
    <path d="M2.60742 12.4863C2.33203 12.2812 2.27344 11.9414 2.43164 11.4785L3.63867 7.89844L0.5625 5.68945C0.164062 5.4082 0 5.09766 0.111328 4.76953C0.222656 4.44727 0.527344 4.29492 1.01367 4.29492H4.78711L5.93555 0.720703C6.08789 0.251953 6.32812 0 6.66797 0C7.01367 0 7.25391 0.251953 7.40039 0.720703L8.54883 4.29492H12.3223C12.8086 4.29492 13.1191 4.44727 13.2305 4.76953C13.3418 5.09766 13.1719 5.4082 12.7793 5.68945L9.70312 7.89844L10.9043 11.4785C11.0625 11.9414 11.0039 12.2812 10.7344 12.4863C10.459 12.6973 10.1133 12.627 9.71484 12.3398L6.66797 10.1016L3.62109 12.3398C3.22266 12.627 2.88281 12.6973 2.60742 12.4863Z"/>
  </svg>
)

/* Checkmark inside a filled selection circle */
const SelectCheckIcon = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.96094 10.166C3.66797 10.166 3.45117 10.043 3.24609 9.79102L0.210938 5.99414C0.0644531 5.8125 0 5.64258 0 5.4668C0 5.0625 0.298828 4.76953 0.708984 4.76953C0.966797 4.76953 1.14258 4.86328 1.3125 5.0918L3.9375 8.46094L9.0293 0.375C9.20508 0.0996094 9.375 0 9.66211 0C10.0723 0 10.3535 0.28125 10.3535 0.685547C10.3535 0.84375 10.3066 1.00781 10.1836 1.19531L4.67578 9.78516C4.50586 10.0371 4.27148 10.166 3.96094 10.166Z" fill="white"/>
  </svg>
)

/* ── Swipe physics constants — tuned for an iOS-Mail-like feel ── */
const DEAD_ZONE = 8            // px before swipe direction is decided (snappier engage)
const SWIPE_THRESHOLD = 78     // px displacement to trigger action
const VELOCITY_THRESHOLD = 0.45 // px/ms — a fast flick triggers even on a short swipe
const MAX_OFFSET = 96          // max visual displacement
const DAMPING = 0.42           // rubber-band resistance past threshold (lower = firmer wall)
const RELEASE_SPRING = 'transform 0.42s cubic-bezier(0.22, 1, 0.36, 1)'  // weighted settle
const PILL_SIZE = { width: 68, height: 44 }

/* Selection circle metrics — slightly larger than the time font but compact.
 * Timestamp uses --text-sm (~13px); circle ≈ 1.4x that. */
const TIME_FONT_PX = 13
const SELECT_CIRCLE = Math.round(TIME_FONT_PX * 1.4)   // smaller than before

function SwipeableLogItem({
  log, onDelete, onStar, renderContent, getLogIcon, formatTimestamp,
  // ── selection mode (Library "Select") ──
  selectMode = false,
  selected = false,
  onToggleSelect,
}) {
  const [offsetX, setOffsetX] = useState(0)
  const [isDragging, setIsDragging] = useState(false)
  const [actionReady, setActionReady] = useState(null) // 'star' | 'delete' | null

  const containerRef = useRef(null)
  const startX = useRef(0)
  const startY = useRef(0)
  const startTime = useRef(0)
  const directionLocked = useRef(null) // 'horizontal' | 'vertical' | null
  const isActive = useRef(false)
  const currentOffset = useRef(0)
  const rafId = useRef(null)

  // Apply rubber-band damping past threshold
  const applyDamping = (dx) => {
    const sign = dx > 0 ? 1 : -1
    const abs = Math.abs(dx)
    if (abs <= SWIPE_THRESHOLD) return dx
    const over = abs - SWIPE_THRESHOLD
    return sign * (SWIPE_THRESHOLD + over * DAMPING)
  }

  const clampOffset = (dx) => {
    const damped = applyDamping(dx)
    return Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, damped))
  }

  const updateVisual = (rawDx) => {
    const clamped = clampOffset(rawDx)
    currentOffset.current = clamped
    setOffsetX(clamped)

    const abs = Math.abs(clamped)
    if (rawDx > 0 && abs >= SWIPE_THRESHOLD * 0.6) setActionReady('star')
    else if (rawDx < 0 && abs >= SWIPE_THRESHOLD * 0.6) setActionReady('delete')
    else setActionReady(null)
  }

  const resetSwipe = () => {
    isActive.current = false
    directionLocked.current = null
    currentOffset.current = 0
    setIsDragging(false)
    setOffsetX(0)
    setActionReady(null)
  }

  const finishSwipe = (rawDx) => {
    const elapsed = Date.now() - startTime.current
    const velocity = Math.abs(rawDx) / Math.max(elapsed, 1)
    const abs = Math.abs(rawDx)
    const triggered = abs >= SWIPE_THRESHOLD || (velocity >= VELOCITY_THRESHOLD && abs > 30)

    if (triggered) {
      if (rawDx > 0) onStar()
      else onDelete()
    }
    resetSwipe()
  }

  /* ── Touch handlers ── */
  const onTouchStart = (e) => {
    if (selectMode) return          // no swipe while selecting
    if (e.touches.length > 1) return
    startX.current = e.touches[0].clientX
    startY.current = e.touches[0].clientY
    startTime.current = Date.now()
    directionLocked.current = null
    isActive.current = true
    setIsDragging(true)
  }

  const onTouchMove = (e) => {
    if (!isActive.current) return
    const dx = e.touches[0].clientX - startX.current
    const dy = e.touches[0].clientY - startY.current

    // Lock direction after dead zone
    if (!directionLocked.current) {
      if (Math.abs(dx) < DEAD_ZONE && Math.abs(dy) < DEAD_ZONE) return
      directionLocked.current = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical'
    }

    if (directionLocked.current === 'vertical') {
      isActive.current = false
      setIsDragging(false)
      return
    }

    e.preventDefault()
    updateVisual(dx)
  }

  const onTouchEnd = () => {
    if (!isActive.current) { resetSwipe(); return }
    const rawDx = currentOffset.current
    finishSwipe(rawDx > 0 ? Math.abs(rawDx) / DAMPING : -Math.abs(rawDx) / DAMPING)
  }

  /* ── Mouse handlers (desktop) ── */
  const onMouseDown = (e) => {
    if (selectMode) return          // no swipe while selecting
    if (e.button !== 0) return
    const tag = e.target.tagName.toLowerCase()
    if (['button', 'a', 'input', 'textarea', 'audio', 'video', 'select'].includes(tag)) return
    if (e.target.closest('button') || e.target.closest('a') || e.target.closest('audio') || e.target.closest('video')) return

    startX.current = e.clientX
    startY.current = e.clientY
    startTime.current = Date.now()
    directionLocked.current = null
    isActive.current = true
    setIsDragging(true)

    const onMove = (me) => {
      if (!isActive.current) return
      const dx = me.clientX - startX.current
      const dy = me.clientY - startY.current

      if (!directionLocked.current) {
        if (Math.abs(dx) < DEAD_ZONE && Math.abs(dy) < DEAD_ZONE) return
        directionLocked.current = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical'
      }

      if (directionLocked.current === 'vertical') {
        cleanup()
        return
      }

      me.preventDefault()
      updateVisual(dx)
    }

    const onUp = () => {
      if (isActive.current) {
        const rawDx = currentOffset.current
        finishSwipe(rawDx > 0 ? Math.abs(rawDx) / DAMPING : -Math.abs(rawDx) / DAMPING)
      }
      cleanup()
    }

    const cleanup = () => {
      window.removeEventListener('mousemove', onMove)
      window.removeEventListener('mouseup', onUp)
      resetSwipe()
    }

    window.addEventListener('mousemove', onMove)
    window.addEventListener('mouseup', onUp)
  }

  // Attach touchmove with passive: false
  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    const handler = (e) => onTouchMove(e)
    el.addEventListener('touchmove', handler, { passive: false })
    return () => el.removeEventListener('touchmove', handler)
  })

  // Action pill opacity based on displacement
  const actionOpacity = Math.min(1, Math.abs(offsetX) / (SWIPE_THRESHOLD * 0.7))
  const actionScale = 0.6 + Math.min(0.4, Math.abs(offsetX) / SWIPE_THRESHOLD * 0.4)

  // Show star next to date if log is whole-starred OR has any per-URL stars
  const hasAnyStar = log.is_starred || (log.starred_urls && log.starred_urls.length > 0)

  /* In select mode, tapping anywhere on the row toggles selection. */
  const handleRowClick = (e) => {
    if (!selectMode) return
    // let inner controls (audio/video) still work, but a plain tap selects
    onToggleSelect && onToggleSelect()
  }

  return (
    <div
      ref={containerRef}
      style={{ position: 'relative', overflow: 'hidden', cursor: selectMode ? 'pointer' : 'default' }}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onMouseDown={onMouseDown}
      onClick={handleRowClick}
    >
      {/* Star action pill (swipe right) — hidden in select mode */}
      {!selectMode && offsetX > 0 && (
        <div style={{
          position: 'absolute', top: 0, left: 0, bottom: 0,
          display: 'flex', alignItems: 'center', paddingLeft: '12px', zIndex: 1,
        }}>
          <div style={{
            width: PILL_SIZE.width + 'px',
            height: PILL_SIZE.height + 'px',
            borderRadius: '100px',
            background: '#343434',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: actionOpacity,
            transform: `scale(${actionScale})`,
            transition: isDragging ? 'none' : 'all 0.2s ease',
            boxShadow: 'none',
          }}>
            <StarFillIcon size={22} />
          </div>
        </div>
      )}

      {/* Delete action pill (swipe left) — hidden in select mode */}
      {!selectMode && offsetX < 0 && (
        <div style={{
          position: 'absolute', top: 0, right: 0, bottom: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: '12px', zIndex: 1,
        }}>
          <div style={{
            width: PILL_SIZE.width + 'px',
            height: PILL_SIZE.height + 'px',
            borderRadius: '100px',
            background: '#343434',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: actionOpacity,
            transform: `scale(${actionScale})`,
            transition: isDragging ? 'none' : 'all 0.2s ease',
            boxShadow: 'none',
          }}>
            <TrashFillIcon size={22} />
          </div>
        </div>
      )}

      {/* Content row */}
      <div style={{
        padding: '16px 0',
        background: 'var(--color-bg-app)',
        position: 'relative',
        zIndex: 2,
        transform: `translateX(${selectMode ? 0 : offsetX}px)`,
        transition: isDragging ? 'none' : RELEASE_SPRING,
        userSelect: isDragging ? 'none' : 'auto',
        willChange: isDragging ? 'transform' : 'auto',
      }}>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            {renderContent(log)}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
              <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)', margin: 0 }}>{formatTimestamp(log.created_at)}</p>
              {hasAnyStar && <StarSmallIcon size={20} />}

              {/* Selection circle — same line as timestamp, 1x bigger than the time font.
                  Pushed to the right edge of the row. */}
              {selectMode && (
                <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                  <span
                    onClick={(e) => { e.stopPropagation(); onToggleSelect && onToggleSelect() }}
                    style={{
                      width: SELECT_CIRCLE + 'px',
                      height: SELECT_CIRCLE + 'px',
                      borderRadius: '50%',
                      border: selected ? 'none' : '1.5px solid rgba(255,255,255,0.9)',
                      background: selected ? 'var(--color-primary)' : 'transparent',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      cursor: 'pointer',
                      transition: 'all 0.15s ease',
                    }}
                  >
                    {selected && <SelectCheckIcon size={Math.round(SELECT_CIRCLE * 0.5)} />}
                  </span>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

/* PERF: React.memo skips re-render if props are shallowly equal. */
export default React.memo(SwipeableLogItem)